export const PLAY_SOUND = 'PLAY_SOUND';
export const RESET_SOUND = 'RESET_SOUND';

export const playSoundAction = (soundType: 'scan_success' | 'scan_failure') => ({
  type: PLAY_SOUND,
  payload: { soundType },
});

export const resetSoundAction = () => ({
  type: RESET_SOUND,
});